/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-03-17 13:44:10
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-12-11 14:02:04
 * @FilePath: /src/api/public.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { httpRequest } from '@/utils/axios';
import { buildChannelCouponParams, type ChannelCouponParams } from '@/utils/channel-coupon-access';
import { getStableClientCyyInfo } from '@/utils/currency/client-currency';
import normalAxios from 'axios';
import type { ApiResponseDefinition } from './types/api-definition';
import { IAbTestingParams } from './types/public';

export const fetchNavList = (type: number) =>
  httpRequest('GET:/api/nav/lists', { params: { type } });

export const fetchCurrency = () => httpRequest('GET:/api/public/currency');

export const fetchJSONValue = (key: string[]) =>
  httpRequest('POST:/api/block_config/get_block_value', { data: { keys: key } });

export const fetchCustomerWalletBalance = () => httpRequest('GET:/api/customer/wallet_balance');

export const fetchGetCountryData = () => httpRequest('GET:/api/public/country');
/**
 * @description: 获取 S3 上传 URL
 * @param {Object} data
 * @return {Promise<Object>}
 */
export const getS3Url = (path: string) =>
  httpRequest('GET:/tools/s3/upload_url', { params: { path } });

export const fetchMeetConditionsApi = (data: { condition_2: number }) =>
  httpRequest('GET:/api/public/branch_rule/meet_conditions', { params: data, data: {} });

export const fetchBlockValue = (data: { keys: string[] }) =>
  httpRequest('POST:/api/block_config/get_block_value', { data });

export const getCrmPointsRules = () => httpRequest('GET:/api/public/crm_point');

// 获取评价标签
export const getReviewLabel = () => httpRequest('GET:/api/public/review_label');

// 获取 IP 地址所属国家
export const getIpCountry = () => httpRequest('GET:/api/public/ip_country');

const appendUrlChannelCouponParams = <T>(
  data: T,
): T | (T & { channel_coupon: ChannelCouponParams }) => {
  if (typeof window === 'undefined' || !data || typeof data !== 'object' || Array.isArray(data)) {
    return data;
  }

  const searchParams = new URLSearchParams(window.location.search);
  const channelCouponParams = buildChannelCouponParams({
    utmSource: searchParams.get('utm_source'),
    utmMedium: searchParams.get('utm_medium'),
    utmCampaign: searchParams.get('utm_campaign'),
    referrer: typeof document !== 'undefined' ? document.referrer : '',
  });

  if (!channelCouponParams) {
    return data;
  }

  const resourceData = data as Record<string, unknown> & {
    channel_coupon?: Partial<ChannelCouponParams>;
  };
  const existingChannelCoupon = resourceData.channel_coupon || {};

  return {
    ...resourceData,
    channel_coupon: {
      source: existingChannelCoupon.source ?? channelCouponParams.source,
      medium: existingChannelCoupon.medium ?? channelCouponParams.medium,
      campaign: existingChannelCoupon.campaign ?? channelCouponParams.campaign,
      forward_domains: existingChannelCoupon.forward_domains ?? channelCouponParams.forward_domains,
    },
  } as T & { channel_coupon: ChannelCouponParams };
};

export const getResourceData = (data: any): Promise<any> =>
  httpRequest('POST:/api/public/resources', { data: appendUrlChannelCouponParams(data) });

// 上报TikTok转化事件给后端
// 新版API：POST请求，使用当前域名，支持所有小语种站点
// 异步上报，不阻塞用户交互
export const reportTtEvent = (data: any): Promise<any> => {
  return normalAxios.post(`${window.location.origin}/api/v1/tiktok/conversion`, data);
};

// facebook pixel 上报事件
// 备注：此处涉及一个隐藏逻辑
// 需求： ZELL-64641 Z站和DE站 各自新加一套转换Api，要求该Api能同时接收两个站点的数据，上报到同一个像素ID下，像素ID：1406039563948158
// 实现：同一份事件数据，上报到Z之后，需要同步上报到DE，通过nginx转发，上报Z的同时，转发上报DE(不涉及前端代码变动，运维服务支持)
export const reportFacebookEvent = (data: any): Promise<any> => {
  return normalAxios.post(`${window.location.origin}/api/v1/facebook/conversion`, data);
};

export const reportSnapchatEvent = (data: any): Promise<any> => {
  // 本地调试
  // return normalAxios.post(`https://test-zeelool.xmslol.cn/api/v1/snapchat/conversion`, data);
  return normalAxios.post(`${window.location.origin}/api/v1/snapchat/conversion`, data);
};

// 领取优惠券
export const obtainCoupon = (data: any) => httpRequest('POST:/api/customer/get_coupon', { data });

const receiveChannelCouponInFlightMap = new Map<string, Promise<any>>();

const getReceiveChannelCouponInFlightKey = (data: {
  strategy_id: number | string;
  source?: string;
  medium?: string;
  campaign?: string;
}) => JSON.stringify([data.strategy_id, data.source || '', data.medium || '', data.campaign || '']);

// 访问渠道领券
export const receiveChannelCoupon = (data: {
  strategy_id: number | string;
  source?: string;
  medium?: string;
  campaign?: string;
}): Promise<any> => {
  const inFlightKey = getReceiveChannelCouponInFlightKey(data);
  const inFlightRequest = receiveChannelCouponInFlightMap.get(inFlightKey);
  if (inFlightRequest) {
    return inFlightRequest;
  }

  const request = Promise.resolve(
    httpRequest('POST:/api/customer/channel_coupon/receive' as any, { data } as any),
  ).finally(() => {
    receiveChannelCouponInFlightMap.delete(inFlightKey);
  });
  receiveChannelCouponInFlightMap.set(inFlightKey, request);
  return request;
};

// 获取短信链接
export const getSmsLink = (params: { code: string; type: string }) =>
  httpRequest('GET:/api/public/get_sms_link', { params, data: {} });

/** SMS 营销落地页：候选号码列表（无请求体） */
export const getSmsMarketingPhones = () =>
  httpRequest('GET:/api/customer/marketing_phone_candidates');

// 获取搜索数据
// TODO: 为什么会有这么骚的接口定义呢？？get_search_data?history 或者 ?hot 来代表不同类型？
export const getSearchDataByType = (type: 'history' | 'hot', data: any) =>
  httpRequest('POST:/api/block/get_search_data', {
    data: { ...data, ...getStableClientCyyInfo() },
    params: { type },
  } as any);

// 获取搜索自动补全的下拉框数据
export const getSearchKeywords = () => httpRequest('GET:/api/products/search_filters');

// 从 Zendesk 查询文章
export const getZendeskAritle = (data: any) =>
  // @ts-ignore TODO: 为什么从文档中找不到这个接口？
  httpRequest('GET:/api/public/zendesk_search', { params: data });

// 获取时间标记，用于防止弹窗频繁显示
export const getTimeSign = (data: { type?: string; second?: number; value?: number }) =>
  // @ts-ignore
  httpRequest('GET:/api/public/get_time_sign', { params: data, data: {} });

/**
 * A/Btest页面请求接口
 * 魔方搜索 ab_testing_config jsonvalue 配置 ab 测
 */
export const getAbTestingData = (data: IAbTestingParams) =>
  httpRequest('GET:/api/public/abtesting', { params: data });

/**
 * 获取公共资源数据（客户端版本）
 * 与服务端 getGlobalInitData 保持一致的参数和数据结构
 * 用于 token 变化时重新获取配置数据、GlobalLayoutShell 首刷等
 */
export const getGlobalInitData = (
  isWeb: boolean,
  data: import('./types/api-definition').GlobalInitRequest,
  options?: { storeIdOverride?: number },
) => {
  const url = isWeb ? 'POST:/api/global/init_web' : 'POST:/api/global/init_wap';
  const axiosConfig =
    options?.storeIdOverride != null
      ? { headers: { 'store-id': String(options.storeIdOverride) } }
      : undefined;
  return httpRequest(
    url as 'POST:/api/global/init_web',
    { data },
    { success: false, fail: true },
    axiosConfig,
  );
};

export const addCollaboration = (data: any) =>
  httpRequest(
    'POST:/api/public/add_collaboration',
    { data },
    {
      success: true,
      fail: true,
    },
  );
type ListByProductIdsParams = {
  product_ids: string;
  [key: string]: string | number | boolean | undefined;
};

type ListByProductIdsRequest = Parameters<
  typeof httpRequest<'GET:/api/products/list_by_product_ids'>
>[1];

const LIST_BY_PRODUCT_IDS_BATCH_SIZE = 40;

const splitProductIds = (productIds: string) =>
  productIds
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);

const chunkProductIds = (productIds: string[]) => {
  const chunks: string[][] = [];
  for (let index = 0; index < productIds.length; index += LIST_BY_PRODUCT_IDS_BATCH_SIZE) {
    chunks.push(productIds.slice(index, index + LIST_BY_PRODUCT_IDS_BATCH_SIZE));
  }
  return chunks;
};

const mergeListByProductIdsResponses = (
  responses: Array<ApiResponseDefinition['GET:/api/products/list_by_product_ids']>,
): ApiResponseDefinition['GET:/api/products/list_by_product_ids'] => {
  const failedResponse = responses.find((response) => response?.code !== 200);
  if (failedResponse) return failedResponse;

  const firstResponse = responses[0] || {};
  const list = responses.flatMap((response) => response?.data?.list || []);
  const totals = responses
    .map((response) => response?.data?.total)
    .filter((total): total is number => typeof total === 'number');

  return {
    ...firstResponse,
    data: {
      ...firstResponse.data,
      list,
      total:
        totals.length === responses.length
          ? totals.reduce((sum, total) => sum + total, 0)
          : list.length,
    },
  };
};

// 根据商品ID列表获取商品信息
export const listByProductIds = (data: ListByProductIdsParams) => {
  const productIds = splitProductIds(data.product_ids);

  if (productIds.length <= LIST_BY_PRODUCT_IDS_BATCH_SIZE) {
    return httpRequest('GET:/api/products/list_by_product_ids', {
      params: data,
    } as unknown as ListByProductIdsRequest);
  }

  return Promise.all(
    chunkProductIds(productIds).map((ids) =>
      httpRequest('GET:/api/products/list_by_product_ids', {
        params: { ...data, product_ids: ids.join(',') },
      } as unknown as ListByProductIdsRequest),
    ),
  ).then(mergeListByProductIdsResponses);
};

// 站点跳转30天不再弹窗
export const markPublicUserCache = () => httpRequest('GET:/api/public/mark_user_cache');

// 用户授权记录
export const storeUserAuthorizationLog = (data: { content_id: number; status: number }) =>
  httpRequest(
    'POST:/api/public/user_authorization_logs_store',
    { data },
    { success: false, fail: false },
  );
